import React, {forwardRef} from 'react';

const CustomScrollPanel = forwardRef(({children, id}, ref) => {
  return (
    <div id={`CustomScrollPanel-${id}`} ref={ref} className="scrollbars overflow-y-auto overflow-x-clip h-[90%] lg:w-[95%] lg:h-[90%] mr-2 md:mr-4 lg:mr-0 deepdive-panel">
      {children}
    </div>
  );
});

export default CustomScrollPanel;
